import ImplantOrderDetails from "./ImplantOrderDetails";
import { ImplantCaseDetailsSectionV2 } from "../../Components/Order-Comps/ImplantCaseDetailsSectionV2";

function ImplantOrderDetailsV2(props) {
  return <ImplantOrderDetails {...props} CaseDetailsComponent={ImplantCaseDetailsSectionV2} />;
}

export default ImplantOrderDetailsV2;
